import Vue from 'vue'
import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHandsWash, faDice, faBiohazard, faAllergies, faDisease, faDizzy, faProcedures, faVirus, faArrowRight, faSkullCrossbones } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHandsWash, faDice, faBiohazard, faAllergies, faDisease, faDizzy, faProcedures, faVirus, faArrowRight, faSkullCrossbones)
Vue.component('font-awesome-icon', FontAwesomeIcon)


console.log(process.env.VUE_APP_FIREBASE_APIKEY)


import * as firebase from 'firebase/app';
import 'firebase/analytics';
var firebaseConfig = {
	apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
	authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
	databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
	projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
	storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID,
	appId: process.env.VUE_APP_FIREBASE_APPID,
	measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();


new Vue({
  render: h => h(App),
}).$mount('#app')
